import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { YearRewardModal } from '@app/my-zone/shared/modals/year-reward-modal/year-reward.modal';
import {
    NewModal,
    PolicyProductIdEnum,
    PolicyValidityStatusCodeEnum,
    PurchasedProductInterface,
    RelationInterface,
} from 'outshared-lib';
import { CommonModule } from '@angular/common';
import { InsuranceCoverageFormComponent } from './insurance-coverage-form';
import { InsuranceCoverageDataComponent, InsuranceCoverageDataListComponent } from './insurance-coverage-data';
import { InsuranceCoverageButtonsComponent } from '@app/my-zone/shared/insurance-coverage/insurance-coverage-buttons';

@Component({
    selector: 'ins-insurance-coverage',
    templateUrl: './insurance-coverage.component.html',
    styleUrls: ['./insurance-coverage.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        InsuranceCoverageDataComponent,
        InsuranceCoverageDataListComponent,
        InsuranceCoverageButtonsComponent,
        InsuranceCoverageFormComponent,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InsuranceCoverageComponent {

    @Input() public purchasedProduct!: PurchasedProductInterface;
    @Input() public relation!: RelationInterface;

    public changeCoverage: boolean;
    public productIdEnum: typeof PolicyProductIdEnum;
    public validityStatusCodeEnum: typeof PolicyValidityStatusCodeEnum;

    constructor(
        private modalService: NewModal,
    ) {
        this.changeCoverage = false;
        this.productIdEnum = PolicyProductIdEnum;
        this.validityStatusCodeEnum = PolicyValidityStatusCodeEnum;
    }

    public getInfo(): boolean {
        this.modalService.open(YearRewardModal);
        return false;
    }

    public toggleChangeCoverage(): void {
        this.changeCoverage = !this.changeCoverage;
    }
}
